// NOTE: Taken from redux-little-router's util/create-matcher.js

import UrlPattern from 'url-pattern';

import routes from '../../../routes';
import { removeQueryAndHash } from './urlGenerator';

const hasTrailingSlash = /\w+\/$/;

const eagerMatcher = (routeList: Array<RouteCache>) => (
  incomingUrl: string,
) => {
  // Discard query strings
  const pathname = removeQueryAndHash(incomingUrl).replace(
    hasTrailingSlash,
    path => path.slice(0, path.length - 1),
  );

  // Find the route that matches the URL
  for (let i = 0; i < routeList.length; i++) {
    const storedRoute = routeList[i];
    const match = storedRoute.pattern.match(pathname);

    if (match) {
      // Return the matched params and user-defined result object
      return {
        route: storedRoute.route,
        params: match,
        result: storedRoute.result,
      };
    }
  }

  return null;
};

const routeTester = (routes: Object) => {
  const routeList = Object.keys(routes)
    .sort()
    .reverse()
    .map(route => ({
      route,
      pattern: new UrlPattern(route),
      result: routes[route],
    }));

  return eagerMatcher(routeList);
};

export default routeTester(routes);
